<template>
  <a-select
    show-search
    placeholder="Select a sponsor"
    :filter-option="false"
    :loading="loading"
    :value="value"
    v-model="model"
    @change="handleChange">
    <a-select-option v-for="item in items.data" :key="item.hash">
      {{ item.sponsor_name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "sponsor-select",
  props: {
    value: {
      type: String
    },
    decorator: {
      type: Array
    }
  },
  data() {
    return {
      model: this.value,
      loading: false,
      items: this.getDefaultPagination()
    }
  },
  created() {
    this.getItems()
  },
  methods: {
    handleChange(value) {
      const filterValue = this.items.data.filter(i => {
        return i.hash === value
      })

      this.$emit('change', filterValue[0])
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.finances.sponsor'))
        .then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
